<nz-modal
  *ngIf="currentNotification"
  [(nzVisible)]="isVisibleBanner"
  nzCentered
  [nzFooter]="null"
  nzClosable
  (nzOnCancel)="handleCancel()"
>
  <ng-container *nzModalContent>
    <div *ngIf="currentNotification" class="d-flex flex-column gap-2 py-1 pr-2">
      <img [src]="currentNotification.media_url" alt="media" max-width="300px" />
      <div class="d-flex flex-column mt-1">
        <h6 class="text-bold text-lg">{{ currentNotification.title }}</h6>
        <div class="d-flex gap-2">
          <span>{{ currentNotification.description }}
            <strong class="font-bold">
              <a
                [href]="currentNotification.url_link"
                target="_blank"
                rel="noopener noreferrer"
                class="text-black text-decoration-none"
              >
                {{ currentNotification.url_link }}
              </a>
            </strong>
          </span>
        </div>
      </div>
    </div>
  </ng-container>
</nz-modal>
